import React, { useState } from 'react';
import Slider from 'react-slick';
import { NavLink } from 'react-router-dom';
import FsLightbox from 'fslightbox-react';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import img1 from "../assets/images/gallery/gallery-2.JPG";
import img2 from "../assets/images/gallery/gallery-6.JPG";
import img3 from "../assets/images/gallery/gallery-19.JPG";
import img4 from "../assets/images/gallery/gallery-12.JPG";
import img5 from "../assets/images/gallery/gallery-10.JPG";
import img6 from "../assets/images/gallery/gallery-11.JPG";
import img7 from "../assets/images/gallery/gallery-15.JPG";
import img8 from "../assets/images/gallery/gallery-18.JPG";
import img9 from "../assets/images/gallery/gallery-13.JPG";

const images = [
  img1, img2, img3, img4, img5, img6, img7, img8, img9
];
const EventGallery = () => {

  const [lightboxController, setLightboxController] = useState({
    toggler: false,
    slide: 1,
  });
  const [isDragging, setIsDragging] = useState(false);

  const openLightbox = (index) => {
    setLightboxController({
      toggler: !lightboxController.toggler,
      slide: index + 1,
    });
  };

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 }
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 }
      }
    ]
  };

  return (
    <section>
      <div className="container home-event-gallary">
        <h3 className="text-center text-uppercase mb-4">Event Gallery</h3>

        <Slider {...sliderSettings} className="mb-4">
          {images && images.map((image, index) => (
            <div className="event-img px-2" key={index}>
              <img
                src={image}
                alt={`gallery ${index + 1}`}
                className="img-fluid"
                onClick={() => {
                  if (!isDragging) {
                    openLightbox(index);
                  }
                }}
                onMouseDown={() => setIsDragging(false)}
                onMouseMove={() => setIsDragging(true)}
                onMouseUp={() => setTimeout(() => setIsDragging(false), 100)}
                style={{
                  width: '100%',
                  height: '250px',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
              />
            </div>
          ))}
        </Slider>

        <div className="text-center">
          <NavLink to="/gallery">
            <button className="btn btn-create">View All</button>
          </NavLink>
        </div>

        {/* Lightbox Modal*/}
        <FsLightbox
          toggler={lightboxController.toggler}
          sources={images}
          slide={lightboxController.slide}
        />
      </div>
    </section>
  );
};

export default EventGallery;
